import { render } from "./XepHangVaNhanXet.vue?vue&type=template&id=b9bb9350&scoped=true"
import script from "./XepHangVaNhanXet.vue?vue&type=script&lang=js"
export * from "./XepHangVaNhanXet.vue?vue&type=script&lang=js"

import "./XepHangVaNhanXet.vue?vue&type=style&index=0&id=b9bb9350&scoped=true&lang=css"

import exportComponent from "E:\\SonPhat\\Project\\BanVe\\banvetaimaypos_fe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9bb9350"]])

export default __exports__